import { BaseApiService } from '@/Services/base-api-service'
import { isAxiosError } from '@/Services/HttpClient/axios-plugin'
import { IPersonEmergencyContact } from '../Models/IPersonEmergencyContact';
import { ITypedValidationResult } from '../Models/IValidationResult';

class personEmergencyContactService extends BaseApiService {
    public constructor() {
        super('PersonEmergencyContact/');
    }

    private static config = {
        headers: {
            'AuthorizationNeeded': true,
            // Other headers can be added here if needed
        }
    };

    public async getByPersonEmergencyContactId(personEmergencyContactId: number, auth0Id: string): Promise<IPersonEmergencyContact> {
        //console.log('Get Person Emergency Contact By Id');
        return this.httpClient.get<IPersonEmergencyContact>(`GetByPersonEmergencyContactId?PersonEmergencyContactId=${personEmergencyContactId}&auth0Id=${auth0Id}`, personEmergencyContactService.config).then(this.handleResponse.bind(this)).catch(this.handleError.bind(this));
    }
    //public async getCounties(): Promise<ICounty[]> {
    public async getByPersonId(personId: number, auth0Id: string): Promise<IPersonEmergencyContact> {
        //console.log('Get Person Emergency Contact By Person');
        return this.httpClient.get<IPersonEmergencyContact>(`GetByPersonId?personId=${personId}&auth0Id=${auth0Id}`, personEmergencyContactService.config).then(this.handleResponse.bind(this)).catch(this.handleError.bind(this));
    }

    public async savePersonEmergencyContact(emergencyContact: IPersonEmergencyContact, auth0Id: string) {
        //console.log('Updating Person Emergency Contact');
        this.httpClient.post<ITypedValidationResult<IPersonEmergencyContact>>(`SavePersonEmergencyContact?auth0Id=${auth0Id}`, emergencyContact, personEmergencyContactService.config).catch(this.handleError.bind(this));
    }

    public async deletePersonEmergencyContact(PersonEmergencyContactId: number, auth0Id: string) {
        //console.log('Deleting Person Emergency Contact: ' + PersonEmergencyContactId);
        this.httpClient.delete(`DeletePersonEmergencyContact?PersonEmergencyContactId=${PersonEmergencyContactId}&auth0Id=${auth0Id}`, personEmergencyContactService.config).catch(this.handleError.bind(this));
    }

}

export const PersonEmergencyContactService: personEmergencyContactService = new personEmergencyContactService();
export function createPersonEmergencyContact(): IPersonEmergencyContact {
    return {
        personEmergencyContactId: 0,
        personId: 0,
        personName: '',
        contactTypeId: 0,
        contactTypeName: '',
        phoneTypeId: 0,
        phoneTypeName: '',
        phoneNumber: '',
        extension: '',
        emailTypeId: 0,
        emailTypeName: '',
        emailAddress: '',
        addressTypeId: 0,
        addressTypeName: '',
        addressLine1: '',
        addressLine2: '',
        city: '',
        stateId: 0,
        stateName: '',
        zipCode: '',
        preferredMethodOfContactId: 0,
        preferredMethodOfContactName: '',
        modifiedBy: '',
        modifiedDate: ''
    };
}